import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import GlossaryComponent from 'components/GlossaryComponent';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Users rely on consistent labels for common actions to predict how to interact with an interface. This list includes the common UI terms and approved action labels for use in IBM UI content and documentation.`}</p>
    </PageDescription>
    <GlossaryComponent mdxType="GlossaryComponent" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      